import axios from '../axios'
import qs from 'qs'

let lang = localStorage.lang;

export default {
    state: {
        analysis_table: [], // 销售分析表格数据
        department_options: [], // 部门参数
        order_op: [], // 订单号选项
        goods_options: [], // 商品搜索框参数
        brand_op: [], // 品牌选项

        // 图表数据
        analysis_num: {},
        analysis_price: {},
    },
    mutations: {
        setAnalysisOrder(state, arg){ // 写入订单号选项
            state.order_op = arg;
        },
        setGoodsOptions(state, arg){ // 写入商品搜索框选项
            state.goods_options = arg;
        },
        setAnalysisBrand(state, arg){ // 写入品牌选项
            state.brand_op = arg;
        },
        setAnalysisDepartment(state, arg){ // 写入部门搜索框参数
            state.department_options = arg;
        },
        setAnalysis(state, arg){ // 写入原始表格数据
            state.analysis_table = arg;
        },
        setAnalysisChart(state, arg){ // 写入图表数据
            state.analysis_num = arg.num || {};
            state.analysis_price = arg.price || {};
        }
    },
    actions: {
        getAnalysisDepartment({ rootState, commit }, arg){ // 获取部门搜索框参数
            let company_id = rootState.user.user_info.company_id,
            url = "/index/sale/member?lang=" + lang + "&company_id=" + company_id + "&branch_id=" + arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setAnalysisDepartment", res.data.department)
                }
            }).catch(() => {})
        },
        getAnalysisOrder({ commit }){ // 获取订单号选项
            let url = "/index/sale/order",
            data = qs.stringify({
                lang
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setAnalysisOrder", res.data.order)
                }
            }).catch(() => {})
        },
        getGoodsOptions({ commit }){ // 获取商品销售分析商品搜索框参数
            let url = "/index/sale/goods?lang=" + lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setGoodsOptions", res.data.goods)
                }
            }).catch(() => {})
        },
        getAnalysisBrand({ commit }){ // 获取品牌选项
            let url = "/index/goodslist/brand?lang="+lang+"&id="+"";
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setAnalysisBrand", res.data.brand)
                }
            }).catch(() => {})
        },
        getAnalysis( { commit }, arg ){ // 获取原始数据
            commit("handleLoading", true);
            commit("setAnalysis", []); // 清空数据
            let { 
                row, 
                start, 
                end, 
                user, 
                branch, 
                department, 
                order_id, 
                goods_id, 
                brand, 
                industry,
                attr: sortAttr = '',
                mode: sortMode = '',
                page = 1
            } = arg,
            url = "/index/sale/raw_data",
            flow = {
                start,
                end,
                user,
                branch,
                department,
                order_id,
                goods_id,
                brand,
                industry
            },
            data = qs.stringify({
                row,
                flow,
                sortAttr,
                sortMode,
                page
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setAnalysis", res.data.info);
                    commit("handleDialog", true);
                    commit('setPage', res.data.page);
                }
            }).catch(err => {
                alert(`获取原始数据接口异常：${err}，请联系管理员`);
            }).finally(() => {commit("handleLoading", false)})
        },
        downloadAnalysis( { commit }, arg ){ // 下载数据分析表格
            commit("handleLoading", true);
            let { row, start, end, user, branch, department, order_id, goods_id, brand, industry } = arg,
            url = "/index/sale/export",
            flow = {
                start,
                end,
                user,
                branch,
                department,
                order_id,
                goods_id,
                brand,
                industry
            },
            param = qs.stringify({
                row,
                flow
            })
            return new Promise((reslove) => {
                axios.post(url, param).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1) reslove(res.data.excel);
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`下载数据分析表格接口异常：${err}，请联系管理员`);
                })
            })
        },
        getAnalysisChart( { commit }, arg ){ // 获取数据分析图表
            commit("handleLoading", true);
            commit("setAnalysisChart", {})
            let { release = "", relend = "" } = arg,
            n_url = "index/sale/order_number",
            p_url = "index/sale/order_amount",
            data = qs.stringify({
                lang,
                release,
                relend
            }),
            getNumber = () => {
                return axios({
                    method: "POST",
                    url: n_url,
                    data
                })
            },
            getPrice = () => {
                return axios({
                    method: "POST",
                    url: p_url,
                    data
                })
            };
            axios.all([getNumber(),getPrice()])
            .then(axios.spread((res1, res2) => {
                commit("handleLoading", false);
                let { code: code1, name: dimensions1, ordernum: source1 } = res1.data,
                { code: code2, name: dimensions2, amount: source2 } = res2.data;
                if(code1 == 1 && code2 == 1){
                    commit("setAnalysisChart", {
                        num: {
                            dimensions: dimensions1,
                            source: source1
                        },
                        price: {
                            dimensions: dimensions2,
                            source: source2
                        }
                    })
                }
            })).catch(err => {
                commit("handleLoading", false);
                alert(`获取数据分析表接口异常：${err}，请联系管理员`);
            })
        }
    }
}